import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const system: AppRouteModule = {
  path: '/system',
  name: 'System',
  component: LAYOUT,
  redirect: '/system/menu',
  meta: {
    orderNo: 2000,
    icon: 'ion:settings-outline',
    title: t('routes.demo.system.moduleName'),
  },
  children: [
    {
      path: 'menu',
      name: 'MenuManagement',
      meta: {
        title: t('routes.demo.system.menu'),
        ignoreKeepAlive: true,
      },
      component: () => import('/@/views/system/menu/index.vue'),
    },
    {
      path: 'application',
      name: 'ApplicationManagement',
      meta: {
        title: '应用管理',
        ignoreKeepAlive: true,
      },
      component: () => import('/@/views/system/application/index.vue'),
    },
    {
      path: 'user',
      name: 'UserManagement',
      meta: {
        title: t('routes.demo.personnel.user'),
        ignoreKeepAlive: true,
      },
      component: () => import('/@/views/system/user/index.vue'),
    },
    {
      path: 'role',
      name: 'RoleManagement',
      meta: {
        title: t('routes.demo.system.role'),
      },
      component: () => import('/@/views/system/role/index.vue'),
    },
    {
      path: 'error',
      name: 'ErrorManagement',
      meta: {
        title: '错误日志',
      },
      component: () => import('/@/views/system/error/index.vue'),
    },
   
  ],
};

export default system;
